<template>
  <div class="container file-view">
    <confirm-dialog
      v-model="deleteFileDialog"
      @confirmed="deleteFile"
    ></confirm-dialog>

    <app-modal v-model="uploadFileDialog" title="Upload File">
      <file-form
        v-model="file"
        :file-to-upload="fileToUpload"
        :selected-file-id="selectedFileId"
        :project-id="$route.params.projectID"
        @updated="updatedFile"
      ></file-form>
    </app-modal>

    <page-header :title="file.name">
      <template v-slot:right>
        <div class="level">
          <div class="level-item">
            <!--button class="button" @click="uploadFileDialog = true">
              <span class="icon icon-edit"></span>
              <span>Edit</span>
            </button-->
          </div>
          <div v-if="hasPermission([40002])" class="level-item">
            <button class="button" @click="deleteFileDialog = true">
              <span class="icon icon-delete"></span>
              <span>Delete</span>
            </button>
          </div>
          <div class="level-item">
            <button class="button" @click="downloadFile">
              <span class="icon icon-download"></span>
              <span>Download</span>
            </button>
          </div>
        </div>
      </template>
    </page-header>

    <div class="file-preview-container pt-30 columns">
      <div class="column is-9">
        <template v-if="extension == 'zip' || extension == 'pdf'">
          <iframe :src="fileContent"></iframe>
        </template>
        <template v-else>
          <img v-if="fileContent != ''" :src="fileContent" />
        </template>
      </div>
      <div class="column is-3">
        <div class="level">
          <div class="level-left has-font-weight-bold">Date added</div>
          <div class="level-right">
            {{ file.createdOnUTC | fullDateString }}
          </div>
        </div>
        <div>
          <div v-if="file.description != ''" class="has-font-weight-bold">
            Notes
          </div>
          {{ file.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import PageHeader from '@/components/PageHeader.vue';
import FileForm from '@/components/forms/FileForm';
import AppModal from '@/components/AppModal';

export default {
  name: 'FileShow',
  components: { ConfirmDialog, PageHeader, AppModal, FileForm },
  data() {
    return {
      uploadFileDialog: false,
      fileToUpload: null,
      selectedFileId: this.$route.params.fileID,

      file: {},
      fileContent: '',
      originalFileContent: '',
      extension: '',
      deleteFileDialog: false
    };
  },
  mounted() {
    this.axiosRequest('get', `Files/${this.$route.params.fileID}`, {})
      .then(response => {
        //console.log(response.data);
        this.file = response.data;

        if (this.file.fileName)
          this.extension = this.file.fileName.substr(
            this.file.fileName.lastIndexOf('.') + 1
          );

        if (this.extension == 'zip') {
          this.unzipFile(this.file);
        } else {
          this.loadFile();
        }
      })
      .catch(error => {
        this.showErrorMessage(error);
      });
  },
  methods: {
    unzipFile(file) {
      if (file.reportHtmlUrl == '' || file.reportHtmlUrl == null) {
        this.axiosRequest('post', `Files/${file.fileID}/UnzipReport`)
          .then(response => {
            //console.log(response);
            this.fileContent = response.data.reportHtmlUrl;
          })
          .catch(error => {
            this.showErrorMessage(error);
          });
      } else {
        this.fileContent = file.reportHtmlUrl;
      }
    },
    loadFile() {
      if (this.file.fileType == 'Link') {
        this.openLink(this.file.linkUrl);
        return;
      }

      this.axiosRequest(
        'get',
        `Files/${this.$route.params.fileID}/Content`,
        null,
        {
          responseType: 'blob'
        }
      )
        .then(response => {
          this.originalFileContent = response.data;
          this.fileContent = window.URL.createObjectURL(
            new Blob([response.data], { type: response.data.type })
          );
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    },
    deleteFile() {
      this.axiosRequest('delete', `Files/${this.file.fileID}`)
        .then(() => {
          this.deleteFileDialog = false;
          this.$router.push({
            name: 'projects.details'
          });
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    },
    downloadFile() {
      if (this.extension == 'zip') {
        this.axiosRequest(
          'get',
          `Files/${this.$route.params.fileID}/Content`,
          null,
          {
            responseType: 'blob'
          }
        )
          .then(response => {
            this.downloadFileToBrowser(this.file, response.data);
          })
          .catch(error => {
            this.showErrorMessage(error);
          });
      } else {
        this.downloadFileToBrowser(this.file, this.originalFileContent);
      }
    },
    updatedFile() {
      this.fileToUpload = null;
      this.uploadFileDialog = false;
    }
  }
};
</script>

<style lang="scss">
.file-view {
  .file-preview-container {
    padding: $block-spacing;
  }

  iframe {
    width: 100%;
    height: 65vh;
  }
}
</style>
